import { parseMemberRoles } from "./roles";
import { expectArray, expectNumber, expectOptionalString, expectRecord, expectString } from "./schema";
export const MEMBER_INVITE_STATUSES = ["active", "consumed", "expired", "revoked"];
function parseStringEnum(value, allowedValues, path) {
    const parsed = expectString(value, path);
    if (!allowedValues.includes(parsed)) {
        throw new Error(`${path} must be one of: ${allowedValues.join(", ")}`);
    }
    return parsed;
}
function hasOwn(record, key) {
    return Object.prototype.hasOwnProperty.call(record, key);
}
function parsePositiveIntegerOrNull(value, path) {
    if (value === null || value === undefined) {
        return null;
    }
    const parsed = expectNumber(value, path);
    if (!Number.isInteger(parsed) || parsed <= 0) {
        throw new Error(`${path} must be a positive integer`);
    }
    return parsed;
}
export function parseMemberInviteStatus(value, path = "memberInviteStatus") {
    return parseStringEnum(value, MEMBER_INVITE_STATUSES, path);
}
export function parseMemberInviteDeliveryArtifacts(value, path = "memberInviteDeliveryArtifacts") {
    const record = expectRecord(value, path);
    return {
        inviteUrl: expectString(record.inviteUrl, `${path}.inviteUrl`)
    };
}
export function parseAdminMemberInvite(value, path = "adminMemberInvite") {
    const record = expectRecord(value, path);
    return {
        inviteId: expectString(record.inviteId, `${path}.inviteId`),
        inviteType: "memberRole",
        targetRoles: parseMemberRoles(record.targetRoles, `${path}.targetRoles`),
        appNickname: expectOptionalString(record.appNickname, `${path}.appNickname`),
        status: parseMemberInviteStatus(record.status, `${path}.status`),
        maxUseCount: expectNumber(record.maxUseCount, `${path}.maxUseCount`),
        usedCount: expectNumber(record.usedCount, `${path}.usedCount`),
        remainingUseCount: expectNumber(record.remainingUseCount, `${path}.remainingUseCount`),
        expiresAt: expectString(record.expiresAt, `${path}.expiresAt`),
        createdByPlatformUserId: expectOptionalString(record.createdByPlatformUserId, `${path}.createdByPlatformUserId`),
        consumedByPlatformUserId: expectOptionalString(record.consumedByPlatformUserId, `${path}.consumedByPlatformUserId`),
        consumedAt: expectOptionalString(record.consumedAt, `${path}.consumedAt`),
        createdAt: expectString(record.createdAt, `${path}.createdAt`),
        updatedAt: expectString(record.updatedAt, `${path}.updatedAt`)
    };
}
export function parseAdminMemberInvitesResponse(value, path = "adminMemberInvitesResponse") {
    const record = expectRecord(value, path);
    return {
        items: expectArray(record.items, parseAdminMemberInvite, `${path}.items`)
    };
}
export function parseCreateAdminMemberInviteRequest(value, path = "createAdminMemberInviteRequest") {
    const record = expectRecord(value, path);
    return {
        targetRoles: parseMemberRoles(record.targetRoles, `${path}.targetRoles`),
        appNickname: expectOptionalString(record.appNickname, `${path}.appNickname`),
        expiresAt: expectOptionalString(record.expiresAt, `${path}.expiresAt`),
        maxUseCount: hasOwn(record, "maxUseCount")
            ? parsePositiveIntegerOrNull(record.maxUseCount, `${path}.maxUseCount`)
            : null
    };
}
export function parseCreateAdminMemberInviteResponse(value, path = "createAdminMemberInviteResponse") {
    const record = expectRecord(value, path);
    return {
        invite: parseAdminMemberInvite(record.invite, `${path}.invite`),
        delivery: parseMemberInviteDeliveryArtifacts(record.delivery, `${path}.delivery`)
    };
}
export function parseConsumeMemberInviteRequest(value, path = "consumeMemberInviteRequest") {
    const record = expectRecord(value, path);
    return {
        token: expectString(record.token, `${path}.token`)
    };
}
